module.exports = __webpack_public_path__ + "static/media/font_regular.f23be908.woff";